
import {defineComponent} from "vue";
import {
  ProductFilterConditionRestDto,
  ProductFilterCriteriumCategoryRestDto,
  ProductFilterCriteriumTrademarkRestDto
} from "@/api/pharma-cpc-mgmt/models";
import {PropType} from "vue/dist/vue";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import ProductList from "@/components/UI/product/ProductList.vue";
import {ProductListSelectionDto} from "@/components/UI/product/ProductListSelectionDto";
import {SelectionTypeEnum} from "@/api/enums/selection-type-enum";
import SelectTrademarks from "@/components/layouts/catalog/SelectTrademarks.vue";
import SelectCategories from "@/components/layouts/catalog/SelectCategories.vue";

export default defineComponent({
  name: "ProductFilterConditionTrademarksCategories",
  components: {
    SelectCategories,
    SelectTrademarks,
    ProductList,
    BaseDeleteButton
  },
  emits: ['update:modelValue', 'filterRemoved'],
  props: {
    modelValue: {
      type: Object as PropType<ProductFilterConditionRestDto>,
      required: true
    },
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      excludedCnkCodes: [] as string[],
      excludedProductCodes: [] as string[],
      trademarkCodes: [] as string[],
      categoryCodes: [] as string[]
    }
  },
  mounted() {
    this.syncFromModelValue();
  },
  watch: {
    modelValue() {
      this.syncFromModelValue();
    }
  },
  methods: {
    syncFromModelValue(): void {
      this.excludedCnkCodes = [...this.modelValue.cnk_codes_excluded ?? []];
      this.excludedProductCodes = [...this.modelValue.product_codes_excluded ?? []];
      this.trademarkCodes = (this.modelValue.product_trademark_filters ?? []).map((criterium: ProductFilterCriteriumTrademarkRestDto) => criterium.trademark_code);
      this.categoryCodes = (this.modelValue.product_category_filters ?? []).map((criterium: ProductFilterCriteriumCategoryRestDto) => criterium.category_code);
    },
    removeCondition(): void {
      this.$emit('filterRemoved');
    },
    updateExcludedProducts(value: ProductListSelectionDto): void {
      this.excludedCnkCodes = value.cnkCodes;
      this.excludedProductCodes = value.productCodes;
      this.emitChanges();
    },
    addTrademark(trademarkCode: string) {
      this.trademarkCodes.push(trademarkCode);
      this.emitChanges();
    },
    removeTrademark(trademarkCode: string) {
      this.trademarkCodes = this.trademarkCodes.filter((code: string) => code !== trademarkCode);
      this.emitChanges();
    },
    addCategory(categoryCode: string) {
      this.categoryCodes.push(categoryCode);
      this.emitChanges();
    },
    removeCategory(categoryCode: string) {
      this.categoryCodes = this.categoryCodes.filter((code: string) => code !== categoryCode);
      this.emitChanges();
    },
    emitChanges(): void {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        cnk_codes_excluded: this.excludedCnkCodes,
        product_codes_excluded: this.excludedProductCodes,
        product_trademark_filters: this.trademarkCodes.map((code: string) => {return {selection_type_code: SelectionTypeEnum.INCLUDE, trademark_code: code};}),
        product_category_filters: this.categoryCodes.map((code: string) => {return {selection_type_code: SelectionTypeEnum.INCLUDE, category_code: code};})
      });
    }
  },
  computed: {
    productSelection(): ProductListSelectionDto {
      return {
        cnkCodes: this.excludedCnkCodes,
        productCodes: this.excludedProductCodes
      };
    },
  }
});
